export default __webpack_public_path__ + "static/Boy-under-stars-5c52b7b21387c60bde330d3525bac5af.jpg";